import React from 'react';
import ReactDOM from 'react-dom/client';
import App from './App.modular';
import HaulerApp from './HaulerApp';
import HaulerApplyPage from './pages/hauler/HaulerApplyPage';
import { ErrorBoundary } from './components/ErrorBoundary';
import { initNativeApp } from './nativeApp';

// Surface routing: env var wins (subdomain deploys), pathname is fallback for local dev.
// /haulers is the canonical Hauler v2 surface.
const surface = process.env.REACT_APP_SURFACE;
const haulerAliases = ["/drivers", "/Haulers", "/Hualers", "/hualers"];
const currentPath = window.location.pathname;
const matchedAlias = haulerAliases.find(alias => currentPath === alias || currentPath.startsWith(`${alias}/`));
if (!surface && matchedAlias) {
  window.history.replaceState(
    { surface: "haulers" },
    "",
    currentPath.replace(matchedAlias, "/haulers") + window.location.search + window.location.hash
  );
}
const path = window.location.pathname;
const isHaulerApply = !surface && path.startsWith('/haulers/apply');
const isHaulerRoute = !isHaulerApply && (
  surface === 'hauler'
  || surface === 'driver'
  || (!surface && path.startsWith('/haulers'))
);

const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(
  <React.StrictMode>
    {isHaulerApply
      ? <ErrorBoundary label="application form"><HaulerApplyPage /></ErrorBoundary>
      : isHaulerRoute
        ? <ErrorBoundary label="Hauler app"><HaulerApp /></ErrorBoundary>
        : <ErrorBoundary label="LoadDash app"><App /></ErrorBoundary>}
  </React.StrictMode>
);

if (typeof window !== 'undefined') {
  const runNativeInit = () => {
    initNativeApp().catch((e) => {
      console.warn('Native init failed after first paint:', e);
    });
  };

  if ('requestAnimationFrame' in window) {
    requestAnimationFrame(() => setTimeout(runNativeInit, 0));
  } else {
    setTimeout(runNativeInit, 0);
  }
}

// PWA service worker registration — minimal, for installability
if ('serviceWorker' in navigator) {
  window.addEventListener('load', () => {
    navigator.serviceWorker.register('/sw.js').catch(() => {});
  });
}

// Capture install prompt for future use
window.__pwaInstallPrompt = null;
window.addEventListener('beforeinstallprompt', (e) => {
  e.preventDefault();
  window.__pwaInstallPrompt = e;
});
